import { Box, Flex, Text, ThemeFontSizeVariable, ThemeSpaceVariable } from "@caspeco/casper-ui-library";
import { useUserContext } from "../hooks/use-user-context";
import { useTranslation } from "react-i18next";

export const EnvironmentHeader = () => {
	const { isSupport, isDeveloper, user, isImpersonating } = useUserContext();
	const { t } = useTranslation();

	const enviroment = import.meta.env.VITE_ENVIROMENT as env;

	const getColor = () => {
		switch (enviroment) {
			case env.DOCKER:
				return "#16A34A";
			case env.DEV:
				return "#2A82C2";
			case env.STAGE:
				return "#A346BC";
			case env.PROD:
				return "#E94D58";
			default:
				break;
		}
	};

	if (enviroment === env.PROD && !isSupport && !isDeveloper && !isImpersonating) {
		return null;
	} else {
		return (
			<Flex
				justifyContent={"center"}
				backgroundColor={getColor()}
				color={"#FFFFFF"}
				px={ThemeSpaceVariable.Small}
				gap={ThemeSpaceVariable.Medium}
			>
				<Text
					fontSize={ThemeFontSizeVariable.Small}
					fontWeight={"bold"}
					lineHeight={ThemeSpaceVariable.Medium}
				>
					{enviroment}
				</Text>
				{isImpersonating && (
					<Box
						ml={"auto"}
						lineHeight={ThemeSpaceVariable.Medium}
						fontSize={ThemeFontSizeVariable.Small}
						textOverflow={"ellipsis"}
						whiteSpace={"nowrap"}
						overflow={"hidden"}
					>
						{t("impersonate")}: {user?.name}
					</Box>
				)}
			</Flex>
		);
	}
};

enum env {
	DOCKER = "DOCKER",
	DEV = "DEV",
	STAGE = "STAGE",
	PROD = "PROD",
}
